<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="22" height="22" />
      <p class="title-bk">生徒情報</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: id ? 'student-id-detail' : 'student-detail', params: id ? { id } : {} }">
        戻る
      </router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmChanged)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">生徒名（生徒ID）</th>
                <td />
                <td>{{ currentStudentDisplay }}</td>
              </tr>
              <StudentPasswordField vid="password" v-model="password" extraRules="required" />
              <StudentPasswordField
                v-model="verifyPassword"
                extraRules="required|verify_password:password"
                label="パスワード（確認）"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-red">実行</button>
          </div>
        </form>
      </ValidationObserver>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="生徒情報に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>生徒情報</template>
        <template v-slot:body>パスワードの変更が完了しました</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { ValidationObserver } from 'vee-validate';
import StudentPasswordField from '@/components/forms/StudentPasswordField.vue';
import { basicStudentNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('student/fetchStudent', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  components: {
    ValidationObserver,
    StudentPasswordField,
    PopUpHolder,
  },
  data() {
    return {
      password: '',
      verifyPassword: '',
    };
  },
  computed: {
    currentStudent() {
      return this.student;
    },
    currentStudentDisplay() {
      return basicStudentNameIdPresent(this.currentStudent);
    },
    ...mapState({
      student: (state) => state.student.student,
    }),
  },
  methods: {
    confirmChanged() {
      let payload = {
        id: this.currentStudent.id,
        password: this.password,
      };
      this.changeStudentPassword(payload).then(() => {
        this.$refs['popup_holder'].show();
      });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      if (this.id) {
        // This path is for TIE and Corporation Role
        this.$logger.debug('Password Changed for ID: ' + this.id);
        this.$router.push({ name: 'student-id-detail', params: { id: this.id } });
      } else {
        // This path is for Corporation Role
        this.$logger.debug('Password Changed');
        this.$router.push({ name: 'student-detail' });
      }
    },
    ...mapActions('student', ['changeStudentPassword']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
</style>
